import React, { useEffect, useState, useRef } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import modal from '~components/modal';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Input, Empty, Skeleton, Checkbox } from 'antd';
import ASSIGNED_LANDLORDS, { FIND_LANDLORDS, SIGNUP_LANDLORD } from './queries';
import ChooseGroup from './chooseGroup';

const ChooseLandlordModal = ({ onClose, visible, refetch, t }) => {
  const inputEl = useRef(null);
  const [queryLandlors, { loading, data }] = useLazyQuery(FIND_LANDLORDS, {
    fetchPolicy: 'no-cache',
  });
  const [queryAssignedLandlord, { data: assignedLandlordData }] = useLazyQuery(ASSIGNED_LANDLORDS, {
    fetchPolicy: 'no-cache',
  });
  const [landInfo, setLandInfo] = useState([]);
  const [chooseLandInfo, setChooseLandInfo] = useState([]);

  const [selectedNums, setSelectedNums] = useState(0);
  const [isSubmitLoading, setSumbitLoading] = useState(false);

  const [signupLandlord] = useMutation(SIGNUP_LANDLORD, {
    onCompleted: response => {
      if (response?.manageLandlords?.result) {
        setSumbitLoading(false);
        onClose();
        refetch();
      }
    },
  });
  useEffect(() => {
    if (visible) {
      inputEl.current.state.value = '';
      queryLandlors();
      queryAssignedLandlord();
    }
  }, [visible]);
  useEffect(() => {
    let landlordData = [];
    let filterData = [];
    let hasAssignNum = 0;
    const assignedLandlordArr = assignedLandlordData?.listLandlordsManager?.landlordsManager;
    if (data?.listManageLandlords?.landlords) {
      let landlordsInfo = [];
      landlordsInfo = data?.listManageLandlords?.landlords?.map(item => ({
        ...item,
        selected: false,
      }));
      // 如果有已经设置过的landord则默认选中

      if (assignedLandlordArr?.length) {
        assignedLandlordArr?.forEach(item => {
          landlordsInfo = landlordsInfo?.map(landlord => {
            if (landlord?.id === item?.landlordId) {
              hasAssignNum = hasAssignNum + 1;
              return { ...landlord, selected: true };
            } else {
              return { ...landlord };
            }
          });
        });
        setSelectedNums(hasAssignNum);
      }

      const countries = landlordsInfo?.map(item => item?.billingCountry?.name?.trim());

      const sortCountries = Array.from(new Set(countries));
      // 国家按字母顺序
      sortCountries.sort(function (a, b) {
        if (a[0] < b[0]) {
          return -1;
        }
        if (a[0] < b[0]) {
          return 1;
        }
        return 0;
      });
      // 筛选每个国家的landlord
      sortCountries?.forEach(countryItem => {
        filterData = landlordsInfo?.filter(
          dataItem => dataItem?.billingCountry?.name?.trim() === countryItem,
        );
        filterData = filterData?.map(item => ({
          id: item?.id,
          name: item?.name,
          countryName: countryItem,
          selected: item?.selected,
        }));
        filterData?.sort(function (a, b) {
          if (a?.name[0]?.toLowerCase() < b?.name[0]?.toLowerCase()) {
            return -1;
          }
          if (a?.name[0].toLowerCase() < b?.name[0].toLowerCase()) {
            return 1;
          }
          return 0;
        });
        landlordData.push({ countryName: countryItem, details: filterData });
      });
    }

    setLandInfo(landlordData);
    setChooseLandInfo(landlordData);
  }, [data, assignedLandlordData]);

  const handleSelectedNum = num => {
    setSelectedNums(num);
  };

  const handleChoose = (index, newArr) => {
    let chooseArr = [...chooseLandInfo];
    chooseArr[index].details = newArr;
    setChooseLandInfo(chooseArr);
  };

  const handleSubmit = () => {
    setSumbitLoading(true);
    let selectedIds = [];
    chooseLandInfo?.forEach(LandlordItem => {
      LandlordItem?.details?.forEach(landlordDetail => {
        if (landlordDetail?.selected) {
          selectedIds.push(landlordDetail?.id);
        }
      });
    });
    signupLandlord({
      variables: {
        input: { landlordIds: selectedIds },
      },
    });
  };

  const handleSearch = e => {
    setSelectedNums(0);
    if (e.target.value) {
      queryLandlors({
        variables: {
          name: e.target.value,
        },
      });
    } else {
      queryLandlors();
    }
  };

  const handleSelectAll = checked => {
    const totalLandlordNum = data?.listManageLandlords?.landlords?.length || 0;
    const newChooseLandInfo = landInfo.map(country => ({
      ...country,
      details: country.details.map(landlord => ({ ...landlord, selected: checked })),
    }));

    setLandInfo(newChooseLandInfo);
    setChooseLandInfo(newChooseLandInfo);
    handleSelectedNum(checked ? totalLandlordNum : 0);
  };
  return (
    <div className="booking__modalWrap">
      <div
        className="booking__modal-close"
        onClick={() => {
          onClose();
        }}
      >
        <button className="booking__modal-closeBtn">
          <CloseOutlined style={{ fontSize: '12px' }} />
        </button>
      </div>
      <div className="booking__modal-title">{t('cms.booking.manage_landlord.modal.title')}</div>

      <div className="booking__modal-desc">
        {t('cms.booking.manage_landlord.modal.select.hint')}
      </div>
      <div className="booking__modal-contentsBox">
        <div className="booking__modal-allSelected">
          <span className="booking__modal-allSelected-title">
            {t('cms.booking.manage_landlord.modal.current.select')}:
          </span>
          <span className="booking__modal-allSelected-value">{selectedNums} Landlords</span>
        </div>
        <div className="booking__modal-search">
          <Input
            placeholder={'Search here'}
            suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            onChange={handleSearch}
            ref={inputEl}
          />
        </div>
        <If condition={data}>
          <div className="booking__modal-contents">
            <If condition={!!landInfo?.length}>
              <div className="booking__checkCountry-box">
                <Checkbox
                  onChange={e => {
                    handleSelectAll(e.target.checked);
                  }}
                >
                  Select All Landlords
                </Checkbox>
              </div>

              <For of={landInfo} each="landlordItem" index="index">
                <ChooseGroup
                  handleChoose={handleChoose}
                  index={index}
                  country={landlordItem?.countryName}
                  data={landlordItem?.details}
                  key={landlordItem?.countryName}
                  selectedNums={selectedNums}
                  handleSelectedNum={handleSelectedNum}
                />
              </For>
            </If>
            <If condition={!landInfo?.length}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </If>
          </div>
        </If>
        <If condition={loading}>
          <Card
            style={{
              width: '100%',
              height: 'calc(100% - 246px)',
              borderBottom: 'none',
              marginTop: 16,
            }}
          >
            <Skeleton loading={loading} active></Skeleton>
          </Card>
        </If>
      </div>
      <div className="booking__modal-footer">
        <Button
          size="large"
          className="booking__modal-btn"
          style={{ marginRight: '16px', fontWeight: 400 }}
          onClick={onClose}
        >
          {t('cms.special_offer.map.property.delete_cancel')}
        </Button>
        <Button
          size="large"
          type="primary"
          className="booking__modal-btn"
          onClick={handleSubmit}
          loading={isSubmitLoading}
        >
          {t('cms.special_offer.confirm.btn')}
        </Button>
      </div>
    </div>
  );
};

export default modal({ className: 'booking__active-modal' })(ChooseLandlordModal);
